var React = require('react');

function BoltInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m276.828141 51.8437319c.171876.1875003.218751.4531256.109376.6875009l-8.43751 18.0781465c-.125001.2343753-.375001.3906255-.656251.3906255-.0625 0-.140625-.0156251-.21875-.0312501-.343751-.1093751-.546876-.4375005-.468751-.7656259l3.078129-12.625015-6.343758 1.5781268c-.0625.0156251-.125.0156251-.1875.0156251-.171875 0-.359376-.0625001-.484376-.1718752-.1875-.1562502-.25-.3906255-.203125-.6093758l3.140629-12.8906409c.078125-.2968748.359375-.5.687501-.5h5.125006c.390625 0 .703126.2968753.703126.6562508 0 .0937501-.031251.1875002-.078126.2812503l-2.671878 7.2343836 6.187508-1.5312518c.0625-.015625.125-.03125.1875-.03125.203125 0 .390625.0937501.53125.2343752z","fill":"#fff","opacity":".5","transform":"translate(-263 -45)"}));
}

BoltInline.defaultProps = {"height":"26","viewBox":"0 0 14 26","width":"14"};

module.exports = BoltInline;

BoltInline.default = BoltInline;
